import { Component, Inject, OnInit } from '@angular/core';
import { VMCreateCategory } from '../../../perform-induction/perform-induction';
import { SafetyFormsService } from '../../../services/safety-forms.service';
import { SafetyInductionService } from '../../../services/safety-induction.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-add-form-catrgory',
  templateUrl: './dialog-add-form-catrgory.component.html',
  styleUrls: ['./dialog-add-form-catrgory.component.scss']
})
export class DialogAddFormCatrgoryComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogAddFormCatrgoryComponent>,
    
    private SafetyFormsService_:SafetyFormsService) { }


  Description: string = "";
  Name: string = "";
  DaysCount:number=7;
  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  AddnewCategory()
  {
    
    let model= new VMCreateCategory();
    model.categoryName=this.Name;
    model.categoryDesc=this.Description
    model.categoryDesc=this.Description
    model.days=this.DaysCount;

 
    this.SafetyFormsService_.AddnewfFormCategory(model).subscribe(res =>{
 
  if(res=true){
    console.log('result', res)
    this.dialogRef.close(true);
   
  }
  
});
  }

}
